export default __webpack_public_path__ + "static/media/img ex_all.6bb35dd7.png";